import { type PartialBy } from "../core/types/helpers";
import {
    type ComSnapCamerakitAdminV2Lens,
    type ComSnapCamerakitAdminV2Group,
    type ComSnapCamerakitAdminV2LensInGroup,
    type InputComSnapCamerakitAdminV2LensInGroup,
    type InputComSnapCamerakitAdminV2Lens,
    type ComSnapCamerakitAdminV2LenssourceModelLensSourceInfo,
    type ComSnapCamerakitAdminV2Organization,
    type ComSnapCamerakitAdminV2VendorDataItem,
    type InputComSnapCamerakitAdminV2VendorDataItem,
    type ComSnapCamerakitAdminV2OrganizationListResponse,
    type ComSnapCamerakitAdminV2LensWithConnections,
    type ComSnapCamerakitAdminV2GroupLensConnection,
    type ComSnapCamerakitAdminV2GroupWithConnections,
    type ComSnapCamerakitAdminV2GroupListWithConnections,
    type ComSnapCamerakitAdminV2LensListWithConnections,
    ComSnapCamerakitAdminV2GroupStatus,
    type GoogleProtobufTimestamp,
    type InputComSnapCamerakitAdminV2Schedule,
    type ComSnapCamerakitAdminV2Schedule,
    type InputComSnapCamerakitAdminV2CreateConnectionRequest,
    type ComSnapCamerakitAdminV2UserInfo,
    type ComSnapCamerakitAdminV2Label,
    type ComSnapCamerakitAdminV2LensCompoundId,
    type InputComSnapCamerakitAdminV2LensCompoundId,
    ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery,
    ComSnapCamerakitAdminV2LenssourceModelLensSourceType,
    type ComSnapCamerakitAdminV2LenssourceModelLensSource,
    type ComSnapCamerakitAdminV2LenssourceLensSourcesMapByType,
    type ComSnapCamerakitAdminV2LenssourceGetLensSourceListResponse,
    type ComSnapCamerakitAdminV2LenssourceGetAffectedGroupsResponse,
    ComSnapCamerakitAdminV2OrganizationUserRole,
    SnapchatReportingOrganicUserDimension,
    type SnapchatReportingOrganicGetOrganicStatsRequest,
    type SnapchatReportingOrganicGetOrganicStatsResponse,
    type SnapchatReportingOrganicOrganicStat,
    type SnapchatReportingOrganicOrganicStatsField,
    type SnapchatReportingOrganicOrganicStatsResponseDimensionEntry,
    type SnapchatReportingOrganicOrganicStatsResponseEntry,
    type SnapchatReportingOrganicOrganicStatsResponseTimeEntry,
    SnapchatReportingOrganicAssetType,
    SnapchatReportingOrganicGranularity,
    SnapchatReportingOrganicMetricField,
    SnapchatReportingOrganicSortDirection,
    type ComSnapCamerakitAdminV2UserPermissions,
    ComSnapCamerakitAdminV2LensStatus as LensStatus,
    type ComSnapCamerakitAdminV2AppInfo,
    ComSnapCamerakitAdminV2Stage,
    ComSnapCamerakitInternalAdminV1ValidateTokenStatus,
    type ComSnapCamerakitAdminV2AuthorizedOperation,
    ComSnapCamerakitAdminV2AuthOperation,
    ComSnapCamerakitAdminV2PlatformType,
    type ComSnapCamerakitAdminV2OrganizationPlatformType,
    type ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionRequest,
    type ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionResponse,
    ComSnapCamerakitAdminV2HostedLensStatus,
    type ComSnapCamerakitAdminV2ApiToken,
} from "../../gql-generated/camkit-types";

type OmitFromOrganizationType = "apps" | "orgAuthorizedOperations" | "internalLabels" | "platformType";

export type Lens = ComSnapCamerakitAdminV2Lens;
export type LensWithConnections = ComSnapCamerakitAdminV2LensWithConnections;
export type LensSourceInfo = ComSnapCamerakitAdminV2LenssourceModelLensSourceInfo;
export type InputLens = InputComSnapCamerakitAdminV2Lens;
export type Group = ComSnapCamerakitAdminV2Group;
export type LensInGroup = ComSnapCamerakitAdminV2LensInGroup;
export type InputLensInGroup = InputComSnapCamerakitAdminV2LensInGroup;
export type VendorDataItem = ComSnapCamerakitAdminV2VendorDataItem;
export type InputVendorDataItem = InputComSnapCamerakitAdminV2VendorDataItem;
export type Organization = PartialBy<ComSnapCamerakitAdminV2Organization, OmitFromOrganizationType>;
export type OrganizationListResponse = ComSnapCamerakitAdminV2OrganizationListResponse;
export type GroupLensConnection = ComSnapCamerakitAdminV2GroupLensConnection;
export type GroupWithConnections = ComSnapCamerakitAdminV2GroupWithConnections;
export type GroupListWithConnections = ComSnapCamerakitAdminV2GroupListWithConnections;
export type LensListWithConnections = ComSnapCamerakitAdminV2LensListWithConnections;
export type GroupStatus = ComSnapCamerakitAdminV2GroupStatus;
export type InputSchedule = InputComSnapCamerakitAdminV2Schedule;
export type InputCreateConnectionRequest = InputComSnapCamerakitAdminV2CreateConnectionRequest;
export type UserInfo = ComSnapCamerakitAdminV2UserInfo;
export type Label = ComSnapCamerakitAdminV2Label;
export type LensCompoundId = ComSnapCamerakitAdminV2LensCompoundId;
export type InputLensCompoundId = InputComSnapCamerakitAdminV2LensCompoundId;
export type ModelLensSource = ComSnapCamerakitAdminV2LenssourceModelLensSource;
export type LensSourceListRequestQuery = ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery;
export type LensSourceType = ComSnapCamerakitAdminV2LenssourceModelLensSourceType;
export type LensSourcesMapByType = ComSnapCamerakitAdminV2LenssourceLensSourcesMapByType;
export type GetLensSourceListResponse = ComSnapCamerakitAdminV2LenssourceGetLensSourceListResponse;
export type GetAffectedGroupsResponse = ComSnapCamerakitAdminV2LenssourceGetAffectedGroupsResponse;
export type Permissions = ComSnapCamerakitAdminV2UserPermissions;
export type OrganizationPlatformType = ComSnapCamerakitAdminV2OrganizationPlatformType;
export type OrganizationApps = Partial<ComSnapCamerakitAdminV2AppInfo>;
export type AuthorizedOperation = ComSnapCamerakitAdminV2AuthorizedOperation;
export type LensMarketplaceRequest = ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionRequest;
export type LensMarketplaceResponse = ComSnapCamerakitAdminV2GetOrgLensMarketplaceSubscriptionResponse;
export const AuthOperation = ComSnapCamerakitAdminV2AuthOperation;
export const OnboardingTokenStatus = ComSnapCamerakitInternalAdminV1ValidateTokenStatus;

export type UserDimension = SnapchatReportingOrganicUserDimension;
export type GetOrganicStatsRequest = SnapchatReportingOrganicGetOrganicStatsRequest;
export type GetOrganicStatsResponse = SnapchatReportingOrganicGetOrganicStatsResponse;
export type OrganicStat = SnapchatReportingOrganicOrganicStat;
export type OrganicStatsField = SnapchatReportingOrganicOrganicStatsField;
export type OrganicStatsResponseDimensionEntry = SnapchatReportingOrganicOrganicStatsResponseDimensionEntry;
export type OrganicStatsResponseEntry = SnapchatReportingOrganicOrganicStatsResponseEntry;
export type OrganicStatsResponseTimeEntry = SnapchatReportingOrganicOrganicStatsResponseTimeEntry;
export type AssetType = SnapchatReportingOrganicAssetType;
export type Granularity = SnapchatReportingOrganicGranularity;
export type MetricField = SnapchatReportingOrganicMetricField;
export type SortDirection = SnapchatReportingOrganicSortDirection;
export type PlatformType = ComSnapCamerakitAdminV2PlatformType;

export const SortDirection = SnapchatReportingOrganicSortDirection;
export const AssetType = SnapchatReportingOrganicAssetType;
export const Granularity = SnapchatReportingOrganicGranularity;
export const MetricField = SnapchatReportingOrganicMetricField;
export const UserDimension = SnapchatReportingOrganicUserDimension;
export const GroupStatus = ComSnapCamerakitAdminV2GroupStatus;
export const LensSourceListRequestQuery = ComSnapCamerakitAdminV2LenssourceGetLensSourceListRequestQuery;
export const LensSourceType = ComSnapCamerakitAdminV2LenssourceModelLensSourceType;
export const AppApiTokenStage = ComSnapCamerakitAdminV2Stage;
export const UserRole = ComSnapCamerakitAdminV2OrganizationUserRole;
export const PlatformEnum = ComSnapCamerakitAdminV2PlatformType;
export const HostedLensStatus = ComSnapCamerakitAdminV2HostedLensStatus;

export type ApiToken = ComSnapCamerakitAdminV2ApiToken;

export const Typename = {
    Group: ({ __typename: "com_snap_camerakit_admin_v2_Group" } as Group).__typename,

    LensInGroup: ({ __typename: "com_snap_camerakit_admin_v2_LensInGroup" } as LensInGroup).__typename,

    VendorDataItem: (
        {
            __typename: "com_snap_camerakit_admin_v2_VendorDataItem",
        } as VendorDataItem
    ).__typename,

    Organization: ({ __typename: "com_snap_camerakit_admin_v2_Organization" } as Organization).__typename,

    OrganizationApps: ({ __typename: "com_snap_camerakit_admin_v2_AppInfo" } as OrganizationApps).__typename,

    OrganizationListResponse: (
        {
            __typename: "com_snap_camerakit_admin_v2_OrganizationListResponse",
        } as OrganizationListResponse
    ).__typename,

    Lens: ({ __typename: "com_snap_camerakit_admin_v2_Lens" } as Lens).__typename,

    GroupLensConnection: ({ __typename: "com_snap_camerakit_admin_v2_GroupLensConnection" } as GroupLensConnection)
        .__typename,

    GroupWithConnections: ({ __typename: "com_snap_camerakit_admin_v2_GroupWithConnections" } as GroupWithConnections)
        .__typename,

    GroupListWithConnections: (
        {
            __typename: "com_snap_camerakit_admin_v2_GroupListWithConnections",
        } as GroupListWithConnections
    ).__typename,

    LensListWithConnections: (
        {
            __typename: "com_snap_camerakit_admin_v2_LensListWithConnections",
        } as LensListWithConnections
    ).__typename,

    LensWithConnections: ({ __typename: "com_snap_camerakit_admin_v2_LensWithConnections" } as LensWithConnections)
        .__typename,

    Timestamp: ({ __typename: "google_protobuf_Timestamp" } as GoogleProtobufTimestamp).__typename,

    Schedule: ({ __typename: "com_snap_camerakit_admin_v2_Schedule" } as ComSnapCamerakitAdminV2Schedule).__typename,

    LensCompoundId: ({ __typename: "com_snap_camerakit_admin_v2_LensCompoundId" } as LensCompoundId).__typename,

    GetLensSourceListResponse: (
        {
            __typename: "com_snap_camerakit_admin_v2_lenssource_GetLensSourceListResponse",
        } as GetLensSourceListResponse
    ).__typename,

    GetAffectedGroupsResponse: (
        {
            __typename: "com_snap_camerakit_admin_v2_lenssource_GetAffectedGroupsResponse",
        } as GetAffectedGroupsResponse
    ).__typename,
};

export { LensStatus };

export enum AuthOperationTypes {
    Create = "CREATE",
    Read = "READ",
    Update = "UPDATE",
    Delete = "DELETE",
}

export enum AppPlatform {
    PLATFORM_TYPE_MOBILE = "Mobile",
    PLATFORM_TYPE_WEB = "Web",
    PLATFORM_TYPE_NONE = "None",
    PLATFORM_TYPE_UNSET = "Unset",
}
